var SERVICE_WORKER_ACTIONS;
(function (SERVICE_WORKER_ACTIONS) {
    SERVICE_WORKER_ACTIONS["ENABLE_SERVICE_WORKER"] = "enable-service-worker";
    SERVICE_WORKER_ACTIONS["DISABLE_SERVICE_WORKER"] = "disable-service-worker";
    SERVICE_WORKER_ACTIONS["INVALIDATE_INFO_CALL_CACHE"] = "invalidate-info-cache";
})(SERVICE_WORKER_ACTIONS || (SERVICE_WORKER_ACTIONS = {}));
export const enableServiceWorker = () => {
    window.postMessage({ type: SERVICE_WORKER_ACTIONS.ENABLE_SERVICE_WORKER }, window.location.origin);
};
export const disableServiceWorker = () => {
    window.postMessage({ type: SERVICE_WORKER_ACTIONS.DISABLE_SERVICE_WORKER }, window.location.origin);
};
export const invalidateSessionInfoCallCache = () => {
    window.postMessage({ type: SERVICE_WORKER_ACTIONS.INVALIDATE_INFO_CALL_CACHE }, window.location.origin);
};
//# sourceMappingURL=service-worker.utils.js.map